import React from "react";
import { Link } from "react-router-dom";

const Post = ({ blogPost }) => {
  return (
    <div className=" shadow-2xl shadow-slate-600 rounded-lg	align mx-5 my-auto   ">
      <h2 className="text-2xl mx-3 uppercase font-semibold   ">{blogPost.category}</h2>
      <h2 className="mx-3 text-lg text-zinc-800 ">{blogPost.title}</h2>
      <h2 className="mx-3 overflow-hidden">{blogPost.content}</h2>
      <h2 className="mx-3 overflow-hidden">{blogPost.author_id}</h2>
      <Link className="mx-3 text-cyan-400" to={`/${blogPost.id}`}>Read...</Link>
    </div>
  );
};

export default Post;
